import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Vendors() {
  const [selectedVendor, setSelectedVendor] = useState<{
    name: string;
    tagline: string;
    minOrder: string;
    freeShipping: string;
    description: string;
    discount?: string;
  } | null>(null);

  const vendors = [
    {
      name: 'Associated Equipment',
      tagline: 'USA made chargers, wheel chargers and more',
      minOrder: '$100',
      freeShipping: '$2000',
      description: 'Leading manufacturer of professional-grade battery chargers and power equipment. Specializing in wheel chargers, industrial battery maintenance systems, and portable power solutions for commercial and institutional applications.'
    },
    {
      name: 'Autel',
      tagline: 'Advanced diagnostic tools and automotive solutions',
      minOrder: '$150',
      freeShipping: '$2500',
      description: 'Global leader in automotive diagnostic equipment and intelligent technology solutions. Providing cutting-edge diagnostic scanners, TPMS tools, and professional automotive service equipment.'
    },
    {
      name: 'Autometer Products',
      tagline: 'Precision instrumentation and gauges',
      minOrder: '$250',
      freeShipping: '$3500 Continental USA / $6500 AK & HI',
      description: 'Premium manufacturer of performance gauges and instrumentation. Trusted by professionals for accurate monitoring solutions across automotive, marine, and industrial applications.'
    },
    {
      name: 'Caig Laboratories',
      tagline: 'Professional contact cleaners and lubricants',
      minOrder: 'Case QTY',
      freeShipping: '$500 and Case QTY',
      description: 'Industry-leading manufacturer of contact cleaners, lubricants, and maintenance products. Specialized formulations for electronics, electrical systems, and precision equipment maintenance.'
    },
    {
      name: 'Clarios – Optima Batteries',
      tagline: 'High-performance AGM battery technology',
      minOrder: '$500',
      freeShipping: 'Not Available',
      description: 'Premium AGM battery solutions delivering exceptional starting power and deep-cycle performance. Trusted by professionals for demanding applications in automotive, marine, and industrial sectors.'
    },
    {
      name: 'CSB Battery',
      tagline: 'Reliable sealed lead-acid battery solutions',
      minOrder: '$100',
      freeShipping: '$3000 to 48 USA',
      description: 'Global manufacturer of valve-regulated lead-acid batteries. Providing dependable power solutions for UPS systems, emergency lighting, security systems, and industrial applications.'
    },
    {
      name: 'Deltran',
      tagline: 'Battery maintenance and charging systems',
      minOrder: 'Case QTY',
      freeShipping: '$1800',
      description: 'Manufacturer of Battery Tender® products and professional charging solutions. Specialized in automatic battery maintenance systems for automotive, powersports, and marine applications.'
    },
    {
      name: 'Dewalt',
      tagline: 'Professional power tools and equipment',
      minOrder: '$150',
      freeShipping: '$2500',
      description: 'Industry-leading manufacturer of professional-grade power tools, hand tools, and accessories. Trusted by contractors and professionals for durability and performance.'
    },
    {
      name: 'Energy Products',
      tagline: 'Industrial battery solutions',
      minOrder: 'No MOQ',
      freeShipping: 'None, $175 per pallet',
      description: 'Specialized manufacturer of industrial battery products and power solutions. Serving material handling, telecommunications, and critical power applications.'
    },
    {
      name: 'EnerSys / Odyssey',
      tagline: 'Extreme performance battery technology',
      minOrder: '$500',
      freeShipping: '$8000 if under 10% of order value',
      description: 'Premium thin plate pure lead (TPPL) battery technology. Delivering exceptional power density, fast recharge, and extreme temperature performance for demanding applications.'
    },
    {
      name: 'EPPCO Gloves',
      tagline: 'Professional safety gloves and PPE',
      minOrder: '1 case',
      freeShipping: '30 cases or more to US 48',
      description: 'Comprehensive line of industrial safety gloves and personal protective equipment. Meeting ANSI standards for cut resistance, chemical protection, and workplace safety.'
    },
    {
      name: 'Lift Safety',
      tagline: 'Innovative safety equipment and PPE',
      minOrder: '$100',
      freeShipping: '$600 US 48',
      description: 'Modern approach to personal protective equipment. Combining safety, comfort, and style in hard hats, safety glasses, gloves, and high-visibility apparel.'
    },
    {
      name: 'ProMariner',
      tagline: 'Marine battery charging systems',
      minOrder: '$200',
      freeShipping: '$3000',
      description: 'Leading manufacturer of marine battery chargers and power conversion products. Specialized solutions for recreational and commercial marine applications.'
    },
    {
      name: 'Marinco',
      tagline: 'Marine electrical products and connectivity',
      minOrder: '$200',
      freeShipping: '$3000',
      description: 'Comprehensive marine electrical solutions including shore power, battery management, and connectivity products. Trusted by boaters and marine professionals worldwide.'
    },
    {
      name: 'Milwaukee',
      tagline: 'Heavy-duty power tools and equipment',
      minOrder: '$150',
      freeShipping: '$2500',
      description: 'Professional-grade cordless and corded power tools. Industry-leading M18 and M12 battery systems with extensive tool lineup for trade professionals.'
    },
    {
      name: 'New Pig',
      tagline: 'Spill containment and safety products',
      minOrder: 'Case QTY',
      freeShipping: '$3500',
      description: 'Comprehensive spill control, containment, and workplace safety solutions. Absorbents, containment systems, and compliance products for industrial facilities.'
    },
    {
      name: 'Power-Sonic',
      tagline: 'Rechargeable battery solutions',
      minOrder: 'Orders under $50 have $15 surcharge, under $100 have $10 surcharge',
      freeShipping: '$5000 (LITHIUM has no free freight due to HAZMAT)',
      description: 'Diverse portfolio of sealed lead-acid and lithium battery technologies. Serving security, medical, telecommunications, and industrial power applications.'
    },
    {
      name: 'Power Storage Solutions',
      tagline: 'Custom battery and power systems',
      minOrder: '$100',
      freeShipping: 'N/A, $50 per pallet',
      description: 'Engineered battery solutions and custom power systems. Specialized in application-specific designs for industrial, medical, and commercial requirements.'
    },
    {
      name: 'Energizer',
      tagline: 'Trusted portable power solutions',
      minOrder: '$200',
      freeShipping: '$750',
      description: 'Global leader in portable batteries and lighting products. Comprehensive range of alkaline, lithium, and rechargeable battery solutions for consumer and professional use.',
      discount: '5% off orders of $1,750 or more'
    },
    {
      name: 'Duracell',
      tagline: 'Long-lasting battery performance',
      minOrder: '$200',
      freeShipping: '$750',
      description: 'Premium alkaline and specialty batteries trusted worldwide. Delivering reliable power for everyday devices and professional applications.',
      discount: '5% off orders of $1,750 or more'
    },
    {
      name: 'Rayovac',
      tagline: 'Value-driven battery solutions',
      minOrder: '$200',
      freeShipping: '$750',
      description: 'Quality alkaline and hearing aid batteries at competitive prices. Trusted performance for consumer and institutional applications.',
      discount: '5% off orders of $1,750 or more'
    },
    {
      name: 'RAMCAR',
      tagline: 'Industrial battery handling equipment',
      minOrder: 'Container and Fill in are available',
      freeShipping: 'See Program',
      description: 'Specialized manufacturer of battery handling systems and material handling equipment. Solutions for safe battery extraction, transport, and installation in industrial facilities.'
    },
    {
      name: 'ROLLS Battery',
      tagline: 'Deep-cycle flooded lead-acid batteries',
      minOrder: 'Container and Fill in are Available',
      freeShipping: 'See Program',
      description: 'Premium flooded lead-acid batteries for renewable energy, marine, and industrial applications. Engineered for deep-cycle performance and extended service life.'
    },
    {
      name: 'Schumacher Electric',
      tagline: 'Battery chargers and jump starters',
      minOrder: 'Case QTY',
      freeShipping: '$2500',
      description: 'Comprehensive range of battery chargers, maintainers, and portable jump starters. Solutions for automotive, marine, and powersports applications.'
    },
    {
      name: 'Trojan Battery',
      tagline: 'Deep-cycle battery technology leader',
      minOrder: '$250',
      freeShipping: '$3500',
      description: 'Industry pioneer in deep-cycle battery technology. Premium flooded, AGM, and gel batteries for renewable energy, golf cars, floor machines, and aerial lifts.'
    },
    {
      name: 'Yuasa',
      tagline: 'Powersports and industrial batteries',
      minOrder: 'Master Carton QTY',
      freeShipping: '$4000 USA 48 ($35 fee if broken case qty)',
      description: 'Leading manufacturer of motorcycle, ATV, and powersports batteries. Also providing industrial battery solutions for material handling and standby power applications.'
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      
      <main className="flex-grow">
        {/* Hero Section with Logo */}
        <section className="relative bg-gradient-to-br from-teal-600 via-teal-700 to-slate-800 pt-32 pb-24 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
            <div className="absolute bottom-10 right-20 w-96 h-96 bg-teal-300 rounded-full blur-3xl"></div>
          </div>
          
          <div className="relative max-w-7xl mx-auto px-6">
            <div className="flex flex-col items-center text-center mb-12">
              {/* Logo */}
              <div className="mb-8 bg-white rounded-2xl p-8 shadow-2xl">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-teal-600 to-teal-700 rounded-lg flex items-center justify-center">
                    <span className="text-white font-bold text-2xl">D</span>
                  </div>
                  <div className="text-left">
                    <div className="text-2xl font-bold text-slate-900">DFF Distribution</div>
                    <div className="text-xs text-teal-600 font-semibold tracking-wider uppercase">Authorized Partners</div>
                  </div>
                </div>
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 max-w-4xl">
                Trusted Brands &amp; Supply Partners
              </h1>
              <p className="text-xl text-teal-50 leading-relaxed max-w-3xl">
                We collaborate with industry-leading manufacturers and authorized distributors to deliver quality products with full compliance documentation and supply chain integrity.
              </p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="bg-white py-16 border-b border-slate-200">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">28+</div>
                <div className="text-sm text-slate-600 font-medium">Authorized Brands</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">100%</div>
                <div className="text-sm text-slate-600 font-medium">Compliance Ready</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">24/7</div>
                <div className="text-sm text-slate-600 font-medium">Supply Support</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">5+</div>
                <div className="text-sm text-slate-600 font-medium">Years Combined</div>
              </div>
            </div>
          </div>
        </section>

        {/* Vendor Grid Section */}
        <section className="bg-gradient-to-b from-slate-50 to-white py-24">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                Our Authorized Vendor Network
              </h2>
              <p className="text-lg text-slate-600 max-w-2xl mx-auto">
                Strategic partnerships with leading manufacturers across multiple product categories
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {vendors.map((vendor, index) => (
                <div 
                  key={index}
                  onClick={() => setSelectedVendor(vendor)}
                  className="group bg-white rounded-xl p-6 flex items-center justify-center text-center border-2 border-slate-200 hover:border-teal-500 hover:shadow-lg transition-all duration-300 cursor-pointer"
                >
                  <div className="flex flex-col items-center gap-2">
                    <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-teal-50 to-teal-100 rounded-lg group-hover:from-teal-500 group-hover:to-teal-600 transition-all duration-300">
                      <i className="ri-verified-badge-line text-xl text-teal-600 group-hover:text-white"></i>
                    </div>
                    <span className="text-slate-700 font-semibold text-sm group-hover:text-teal-700 transition-colors">
                      {vendor.name}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="bg-white py-20 border-t border-slate-200">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center p-8 rounded-xl bg-gradient-to-br from-teal-50 to-teal-100/50">
                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl flex items-center justify-center shadow-lg">
                  <i className="ri-shield-check-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Authorized Distribution</h3>
                <p className="text-slate-600 leading-relaxed">
                  Direct partnerships with manufacturers ensuring authentic products and warranty support
                </p>
              </div>

              <div className="text-center p-8 rounded-xl bg-gradient-to-br from-slate-50 to-slate-100/50">
                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-slate-700 to-slate-800 rounded-xl flex items-center justify-center shadow-lg">
                  <i className="ri-file-list-3-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Full Compliance</h3>
                <p className="text-slate-600 leading-relaxed">
                  Complete documentation and certifications for institutional and municipal requirements
                </p>
              </div>

              <div className="text-center p-8 rounded-xl bg-gradient-to-br from-teal-50 to-teal-100/50">
                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl flex items-center justify-center shadow-lg">
                  <i className="ri-truck-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Supply Chain Integrity</h3>
                <p className="text-slate-600 leading-relaxed">
                  Reliable inventory management and fulfillment backed by established supply networks
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Disclaimer Section */}
        <section className="bg-slate-50 py-16">
          <div className="max-w-7xl mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white border-l-4 border-teal-600 rounded-lg p-8 shadow-sm">
                <div className="flex gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center">
                      <i className="ri-information-line text-xl text-teal-600"></i>
                    </div>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-slate-900 mb-3">Important Notice</h4>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      Brand availability may vary by program, contract, or supply channel. Listing does not imply exclusivity or endorsement. DFF Distribution operates as an authorized distributor within established supply networks. Product availability, specifications, and fulfillment terms are subject to manufacturer guidelines and contractual agreements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* Vendor Details Modal */}
      {selectedVendor && (
        <div 
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedVendor(null)}
        >
          <div 
            className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="sticky top-0 bg-gradient-to-br from-teal-600 to-teal-700 p-6 rounded-t-2xl">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                    <i className="ri-verified-badge-fill text-3xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-1">{selectedVendor.name}</h3>
                    <p className="text-teal-50 text-sm">{selectedVendor.tagline}</p>
                  </div>
                </div>
                <button
                  onClick={() => setSelectedVendor(null)}
                  className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-lg transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl text-white"></i>
                </button>
              </div>
            </div>

            <div className="p-6 space-y-6">
              <div>
                <h4 className="text-lg font-bold text-slate-900 mb-3">About This Vendor</h4>
                <p className="text-slate-600 leading-relaxed">{selectedVendor.description}</p>
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-gradient-to-br from-teal-50 to-teal-100/50 rounded-xl p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
                      <i className="ri-shopping-cart-line text-xl text-white"></i>
                    </div>
                    <div>
                      <div className="text-xs text-slate-600 font-medium">Minimum Order</div>
                      <div className="text-xl font-bold text-teal-700">{selectedVendor.minOrder}</div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-slate-50 to-slate-100/50 rounded-xl p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-slate-700 rounded-lg flex items-center justify-center">
                      <i className="ri-truck-line text-xl text-white"></i>
                    </div>
                    <div>
                      <div className="text-xs text-slate-600 font-medium">Free Freight At</div>
                      <div className="text-xl font-bold text-slate-700">{selectedVendor.freeShipping}</div>
                    </div>
                  </div>
                </div>
              </div>

              {selectedVendor.discount && (
                <div className="bg-gradient-to-br from-amber-50 to-amber-100/50 border-2 border-amber-300 rounded-xl p-5">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-percent-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <div className="text-xs text-amber-700 font-semibold uppercase tracking-wide mb-1">Special Discount</div>
                      <div className="text-lg font-bold text-amber-900">{selectedVendor.discount}</div>
                    </div>
                  </div>
                </div>
              )}

              <div className="bg-teal-50 border-l-4 border-teal-600 rounded-lg p-4">
                <div className="flex gap-3">
                  <div className="flex-shrink-0">
                    <i className="ri-information-line text-xl text-teal-600"></i>
                  </div>
                  <p className="text-sm text-slate-600 leading-relaxed">
                    Terms and availability subject to manufacturer guidelines and contractual agreements. Contact us for current pricing, lead times, and program eligibility.
                  </p>
                </div>
              </div>

              <div className="flex gap-3 pt-4">
                <Link
                  to="/contact"
                  className="whitespace-nowrap flex-1 inline-flex items-center justify-center px-6 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line text-lg mr-2"></i>
                  Request Quote
                </Link>
                <button
                  onClick={() => setSelectedVendor(null)}
                  className="whitespace-nowrap px-6 py-3 bg-slate-100 text-slate-700 font-semibold rounded-lg hover:bg-slate-200 transition-colors cursor-pointer"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
